export default __webpack_public_path__ + "static/media/afaLogo.2344631d.png";